import propTypes from 'prop-types';
import React from 'react';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Moment from 'react-moment';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router';
import { deleteImage } from '../../actions/gallery';


const ImageItem = ({
    auth, deleteImage,
    image: { _id, imgurl, imgtype, imgalt, date },
}) => {

const navigate = useNavigate();

return (
    <Col>
        <Card border='warning' >
            <Card.Img variant="top" src={imgurl} style={{maxHeight:'200px'}} />
            <Card.Body>
                <table className='room-card-table'>
                    <tbody>
                        <tr>
                            <td>
                                <tr><td>Date</td><td>{<Moment format='YYYY/MM/DD'>{date}</Moment>}</td></tr>
                                <tr><td>Image Type</td><td>{imgtype}</td></tr>
                                <tr><td>Image Alt</td><td>{imgalt}</td></tr>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </Card.Body>
            <Card.Footer>
                <i className="fas fa-trash" style={{color:'red', float: 'right'}} onClick={() => deleteImage(_id, navigate)}/>
            </Card.Footer>
        </Card>
    </Col>
)};

ImageItem.propTypes = {
    gallery: propTypes.object.isRequired,
    auth: propTypes.object.isRequired,
    deleteImage: propTypes.func.isRequired
};

const mapStateToProps = (state) => ({
    auth: state.auth
});

export default connect(mapStateToProps, { deleteImage })(ImageItem);